export const defaultServer = "https://dev1-server.miniroyale.io/graphql/api";
